import { compact, getSlotCompoundVariant, memo, splitProps } from '../helpers.mjs';
import { createRecipe } from './create-recipe.mjs';

const timeTrackerTitleDefaultVariants = {}
const timeTrackerTitleCompoundVariants = []

const timeTrackerTitleSlotNames = [
  [
    "root",
    "timeTrackerTitle__root"
  ],
  [
    "message",
    "timeTrackerTitle__message"
  ],
  [
    "action",
    "timeTrackerTitle__action"
  ]
]
const timeTrackerTitleSlotFns = /* @__PURE__ */ timeTrackerTitleSlotNames.map(([slotName, slotKey]) => [slotName, createRecipe(slotKey, timeTrackerTitleDefaultVariants, getSlotCompoundVariant(timeTrackerTitleCompoundVariants, slotName))])

const timeTrackerTitleFn = memo((props = {}) => {
  return Object.fromEntries(timeTrackerTitleSlotFns.map(([slotName, slotFn]) => [slotName, slotFn.recipeFn(props)]))
})

const timeTrackerTitleVariantKeys = []
const getVariantProps = (variants) => ({ ...timeTrackerTitleDefaultVariants, ...compact(variants) })

export const timeTrackerTitle = /* @__PURE__ */ Object.assign(timeTrackerTitleFn, {
  __recipe__: false,
  __name__: 'timeTrackerTitle',
  raw: (props) => props,
  variantKeys: timeTrackerTitleVariantKeys,
  variantMap: {},
  splitVariantProps(props) {
    return splitProps(props, timeTrackerTitleVariantKeys)
  },
  getVariantProps
})